import { render, staticRenderFns } from "./NewTransactionBanner.vue?vue&type=template&id=e2f747c8&"
import script from "./NewTransactionBanner.vue?vue&type=script&lang=ts&"
export * from "./NewTransactionBanner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports